(() => {
  function initialiseEpsonMenu(scope = document) {
    scope.querySelectorAll('.ffm-nav').forEach((menu) => {
      if (menu.dataset.epMenuReady) return;
      menu.dataset.epMenuReady = 'true';
      const trigger = menu.querySelector(':scope > summary');
      menu.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault();
          event.stopPropagation();
          menu.open = false;
          trigger.focus({ preventScroll: true });
        }
        if (event.target === trigger && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
          event.preventDefault();
          menu.open = true;
          const links = Array.from(menu.querySelectorAll('.ffm-panel a[href]'));
          (event.key === 'ArrowDown' ? links[0] : links[links.length - 1])?.focus();
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseEpsonMenu());
  else initialiseEpsonMenu();
  document.addEventListener('shopify:section:load', (event) => initialiseEpsonMenu(event.target));
})();

